// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ccDV","top":"styles_top__3JW-O"};